import { Paper } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement } from "react";
import { Outlet, useParams } from "react-router-dom";
import TaskTypes from "../hooks/taskTypes/taskTypes";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function TaskTypesPage(): ReactElement {
  const params = useParams();

  if (params.id)
    return (
      <Box sx={{ flex: 1, minWidth: 0, display: "flex", width: "100%" }}>
        <Outlet />
      </Box>
    );
  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        background: "none",
        flex: 1,
        minWidth: 0,
        p: 2,
        gap: 2,
        width: "100%",
        position: "relative",
      }}
    >
      <Paper sx={{ flex: 1, minWidth: 0, border: "none", display: "flex" }}>
        <TaskTypes />
      </Paper>
    </Box>
  );
}
